<template>
  <div>
    <div class="card card-body p-0 mt-2 w-100" style="border-radius: 10px">
    <div class=" d-flex mb-3" style="width:100%">
      <div class="d-flex row justify-content-start px-2 mt-2 d-flex align-items-center" style="width:75%">
        <div class="col-4" v-if="$can('filter_team')">
          <!-- {{teams}} -->
          <div class="form-group">
            <label style="color: #48a6a6; font-weight: 600; font-size: 14px"
              >Team</label
            >
            <multiselect
              :multiple="true"
              @input="changeTeams()"
              :options="teams"
              :selectedLabel="null"
              :deselectLabel="null"
              :allow-empty="true"
              :selectLabel="null"
              :searchable="true"
              v-model="department"
              label="name"
              track-by="id"
              style="font-size: 12px !important"
              placeholder="Team"
            >
            </multiselect>
          </div>
        </div>
        <!-- {{developers}} -->
        <div class="col-4" v-if="$can('filter_developer')">
          <div class="form-group">
            <label style="color: #48a6a6; font-weight: 600; font-size: 14px"
              >Developer</label
            >
            <multiselect
              :options="allDevelopers"
              :selectedLabel="null"
              :deselectLabel="null"
              :allow-empty="true"
              :selectLabel="null"
              :searchable="true"
              v-model="developer"
              label="full_name"
              track-by="id"
              style="font-size: 12px !important"
              placeholder="Developer"
            >
            </multiselect>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label
              class="color-default"
              style="font-weight: 600; font-size: 14px"
            >
              Date Range</label
            >
            <multiselect
              @input="shortTerm($event)"
              placeholder="Follow-up range"
              :options="short_term_filter"
              :selectedLabel="null"
              :deselectLabel="null"
              :allow-empty="false"
              :selectLabel="null"
              :searchable="true"
              v-model="select_followUp"
              label="name"
              track-by="value"
              style="font-size: 12px !important"
            >
            </multiselect>
          </div>
        </div>
        <div class="col-3 form-group"
          v-if="
            select_followUp.value === 8 ||
            select_followUp.name === 'Custom Date'
          ">
          <label class="color-default" style="font-weight: 600; font-size: 14px"
            >From</label
          >
          <input
            type="date"
            style="font-size: medium"
            class="form-control"
            v-model="startDate"
          />
        </div>
        <div class="col-3 form-group"
          v-if="
            select_followUp.value === 8 ||
            select_followUp.name === 'Custom Date'">
          <label class="color-default" style="font-weight: 600; font-size: 14px"
            >To</label
          >
          <input
            type="date"
            style="font-size: medium"
            class="form-control"
            v-model="endDate"
            @input="applyFilter"
          />
        </div>
        <!-- <div class="col-3 mt-1 mt-1 d-flex justify-content-end">
          <div class="form-group" style="text-align: end">
            <label class=""></label>
            <div
              class="type-label has-search"
              style="width: 100% !important"
              v-if="$can('search')"
            >
              <span class="fa fa-search form-control-feedback"></span>
              <input
                type="text"
                style="background-color: #edf2f5"
                class="form-control"
                v-model="search"
                @keyup="usersBySearch"
                placeholder="Search User..."
              />
            </div>
          </div>
        </div> -->
      </div>
       <div class="col-3 d-flex justify-content-end">
          <div class="form-group mt-3 mb-0" style="text-align: end">
            <label class=""></label>
            <div
              class="type-label has-search"
              style="width: 100% !important"
              v-if="$can('search')"
            >
              <span class="fa fa-search form-control-feedback"></span>
              <input
                type="text"
                style="background-color: #edf2f5"
                class="form-control"
                v-model="search"
                @keyup="usersBySearch"
                placeholder="Search User..."
              />
            </div>
          </div>
        </div>
</div>
      <!-- table -->
      <table class="table table-hover cheat border mx-0 px-0">
        <thead>
          <tr
            style="color: #48a6a6; background-color: #f4f8fa; width: 100%"
            class="text-start"
          >
            <th class="d-flex justify-content-start border-0" style="width: 340px">
              Task Title
            </th>
            <th colspan="2" class="border-0">Progress Date</th>
            <th class="border-0">Team</th>
            <th class="border-0">Developer</th>
            <th class="border-0">Actions</th>
          </tr>
        </thead>
        <tbody ref="formContainer">
          <tr
            v-if="isLoader"
            idd-flex
            justify-content-end
            px-2
            mt-2
            d-flex
            align-items-center="table_row"
          >
            <td colspan="16">
              <b-skeleton-wrapper>
                <b-skeleton height="40px"></b-skeleton>
                <b-skeleton height="40px"></b-skeleton>
                <b-skeleton height="40px"></b-skeleton>
              </b-skeleton-wrapper>
            </td>
          </tr>

          <tr
            v-show="!isLoader"
            v-for="report in reports"
            :key="report.id"
            class="text-left"
          >
            <td class="d-flex align-items-start py-4" style="gap: 5px">
              <a @click="quickView(report)">
                <i
                  :data-id="report.id"
                  class="fa fa-eye color-default"
                  style="cursor: pointer"
                >
                </i>
              </a>
              <div style="width: 350px; word-wrap: break-word">
                <a @click="quickView(report)">
                  <i :data-id="report.id" style="cursor: pointer; font-style:normal">
                    {{ report.title }}
                  </i>
                </a>
              </div>
            </td>
            <td>{{ report.report_date | createdFormateData }}</td>
            <td></td>
            <td>{{ report.name }}</td>
            <td>{{ report.first_name + " " + report.last_name }}</td>

            <td class="text-center">
              <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                <span class="fas fa-ellipsis-v"></span>
              </a>
              <ul class="dropdown-menu action-list">
                <!-- <li><router-link :to="'/development-tasks/schedular'" class="dropdown-item"> View</router-link></li> -->
                <li>
                  <a
                    class="dropdown-item"
                    :data-id="report.id"
                    @click="quickView(report)"
                  >
                    View</a
                  >
                </li>
              </ul>
            </td>
          </tr>
          <tr v-if="reports.length < 1 && !isLoader">
            <td colspan="8" class="text-center">No Record Found</td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="!isLoader"
        class="container-fluid"
        style="font-size: 14px; bottom: 0"
      >
        <div class="row mt-1 justify-content-end d-flex float-right px-3">
          <span class="pr-3 pt-1"
            >Display Rows: <b>{{ totalRows }}</b></span
          >
          <paginate
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="setPage"
            :prev-text="''"
            :next-text="''"
            :first-button-text="''"
            :last-button-text="''"
            :first-last-button="true"
            :container-class="'pagination pagination-sm ml-auto mr-4'"
            :page-class="'page-item'"
            :prev-class="'page-item prev'"
            :next-class="'page-item next'"
            :page-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
          ></paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TaskFilter from "../common/development/task/filter";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import VueSkeletonLoader from "skeleton-loader-vue";
import progressquickView from "./progress_quickView.vue";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Vue from "vue";

Vue.filter("createdFormateData", function (value) {
  if (value != "0000-00-00 00:00:00" && value != null) {
    return moment(String(value)).format("MMM DD, Y");
  }
});
export default {
  components: {
    Multiselect,
    VueSkeletonLoader,
    DateRangePicker,
  },

  data() {
    return {
      search: "",
      team_developers: [],
      team_id: [],
      developer: "",
      page: 0,
      developers: [],
      department: [],
      isLoader: true,
      filter_team_id: [],
      filter_assigned_to: [],
      allDevelopers: [],
      due_date_range_calender: {},
      user_id: "",
      startDate: "",
      endDate: "",
      awaitingSearch: false,
      report: "",
      select_followUp: [],
      short_term_filter: [
        {
          name: "Today",
          start_date: moment().format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),
          value: "0",
        },
        {
          name: "Yesterday",
          start_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          end_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
          value: "1",
        },
        
        {
          name: "Last week",
          start_date: moment()
            .subtract(1, "weeks")
            .startOf("isoWeek")
            .format("YYYY-MM-DD"),
          end_date: moment()
            .subtract(1, "weeks")
            .endOf("isoWeek")
            .format("YYYY-MM-DD"),
          value: "2",
        },
        {
          name: "This week",
          start_date: moment().startOf("isoWeek").format("YYYY-MM-DD"),
          end_date: moment().endOf("isoWeek").format("YYYY-MM-DD"),
          value: "3",
        },
       
        {
          name: "Last Month",
          start_date: moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD"),
          end_date: moment()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD"),
          value: "4",
        },
        {
          name: "This Month",
          start_date: moment().startOf("month").format("YYYY-MM-DD"),
          end_date: moment().endOf("month").format("YYYY-MM-DD"),
          value: "5",
        },
        
        {
          name: "Last Year",
          start_date: moment()
            .subtract(1, "years")
            .startOf("year")
            .format("YYYY-MM-DD"),
          end_date: moment()
            .subtract(1, "years")
            .endOf("year")
            .format("YYYY-MM-DD"),
          value: "6",
        },
        {
          name: "This Year",
          start_date: moment().startOf("year").format("YYYY-MM-DD"),
          end_date: moment().endOf("year").format("YYYY-MM-DD"),
          value: "7",
        },
      
        { name: "Custom Date", start_date: "", end_date: "", value: "8" },
      ],
    };
  },

  created() {
    this.select_followUp = this.short_term_filter[0];
    this.shortTerm(this.short_term_filter[0]);
    let team_id = this.team_id;
    let user = this.user_id;
    let startdate = this.startDate;
    let enddate = this.endDate;
    this.search = "";
    let product_id = localStorage.getItem("product");

    this.$store
      .dispatch("users/gettaskprogressBySearch", [
        team_id,
        user,
        startdate,
        enddate,
        "",
        product_id,
      ])
      .then(() => {
        this.isLoader = false;
      });
    this.getDevelopersList();

    for (const team of this.teams) {
      team.user_team.forEach((user) => {
        if (user.user_id == this.user_id) {
          this.department.push(team);
        }
      });
    }
  },
  watch: {
    department: function () {
      if (!this.department) {
        this.filter_team_id = [];
      } else {
        let product_id = localStorage.getItem("product");
        this.search = "";
        let user = this.user_id;
        let startdate = this.startDate;
        let enddate = this.endDate;
        this.team_id = this.department.map(({ id }) => id);
        this.filter_team_id = this.team_id;
        console.log(this.filter_team_id);
        this.developer = "";
        this.$store
          .dispatch("users/gettaskprogressBySearch", [
            this.team_id,
            user,
            startdate,
            enddate,
            "",
            product_id,
          ])
          .then(() => {});
      }
    },
    developers: function (newValue) {
      if (this.department.length) {
        this.allDevelopers = [];
        for (const department of this.department) {
          const teamDeveloperIds = department.team_developer.map(
            (developer) => developer.user_id
          );

          const departmentDevelopers = this.developers.filter((developer) =>
            teamDeveloperIds.includes(developer.id)
          );
          this.allDevelopers.push(...departmentDevelopers);
        }
        this.allDevelopers = [...new Set(this.allDevelopers)];
      } else {
        this.allDevelopers = this.developers;
      }
    },
    developer: function () {
      let product_id = localStorage.getItem("product");
      let team = this.team_id;
      let startdate = this.startDate;
      let enddate = this.endDate;
      this.search = "";
      this.user_id = this.developer != null ? this.developer.id : "";
      this.filter_assigned_to = this.user_id;
      this.$store
        .dispatch("users/gettaskprogressBySearch", [
          team,
          this.user_id,
          startdate,
          enddate,
          "",
          product_id,
        ])
        .then(() => {});
    },
  },
  computed: {
    ...mapGetters("persist", ["teams"]),
    currentPage: {
      get: function () {
        return this.page;
      },
      set: function () {},
    },

    reports: function () {
      return this.$store.getters["users/reports"];
    },
    totalPages: function () {
      return this.$store.getters["users/totalPages"];
    },
    totalRows: function () {
      return this.$store.getters["users/totalRows"];
    },
  },
  methods: {
    applyFilter(e) {
      console.log(e.target.value);
      this.shortTerm(this.filter_event, this.startDate, this.endDate);
      const permission = {
        headers: {
          "X-Permission": "view_task_progress",
        },
      };
    },
    shortTerm(event, startDate = "", endDate = "") {
      this.filter_event = event;
      this.skeletonLoader = true;
      let product_id = localStorage.getItem("product");
      this.search = "";
      let team = this.team_id;
      let user = this.user_id;
      let followup_filter = event.value;
      if (followup_filter === "8") {
        startDate = this.startDate;
        endDate = this.endDate;
      } else {
        const selectedRange = this.short_term_filter.find(
          (range) => range.value === followup_filter
        );
        startDate = selectedRange.start_date;
        endDate = selectedRange.end_date;
      }
      this.startDate = startDate;
      this.endDate = endDate;

      this.$store
        .dispatch("users/gettaskprogressBySearch", [
          team,
          user,
          startDate,
          endDate,
          "",
          product_id,
        ])
        .then(() => {});
    },
    usersBySearch() {
      let product_id = localStorage.getItem("product");
      let team = this.team_id;
      let user = this.user_id;
      let startdate = this.startDate;
      let enddate = this.endDate;
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.isLoader = true;
          this.$store
            .dispatch("users/gettaskprogressBySearch", [
              team,
              user,
              startdate,
              enddate,
              this.search,
              product_id,
            ])
            .then(() => {
              this.isLoader = false;
            });
          this.awaitingSearch = false;
        }, 200);
      }
      this.awaitingSearch = true;
    },
    truncate(text, length = 5) {
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    quickView(report) {
      this.$store.dispatch("modal/progressquickView", {
        action: "create",
        title: "Progress Detail",
        formData: {
          report: report,
        },
        component: progressquickView,
      });
    },

    setPage(page) {
      this.page = page;
      this.$router.push("admin-users?page=" + page);
    },

    getDevelopersList() {
      this.$store.dispatch("users/getUserList", ["developer"]).then((res) => {
        this.developers = res.map(({ id, full_name }) => ({ id, full_name }));
      });
    },

    changeTeams() {
      if (!this.department.length) {
        this.filter_team_id = [];
        this.allDevelopers = this.developers;
        this.developer = "";
      } else {
        this.allDevelopers = [];
        for (const department of this.department) {
          const teamDeveloperIds = department.team_developer.map(
            (developer) => developer.user_id
          );
          const departmentDevelopers = this.developers.filter((developer) =>
            teamDeveloperIds.includes(developer.id)
          );
          this.allDevelopers.push(...departmentDevelopers);
        }
        this.allDevelopers = [...new Set(this.allDevelopers)];
      }
    },
  },
};
</script>
<style>
.form-group-task .vue-daterange-picker {
  width: 100%;
}
</style>
